import React from 'react';
import { DocumentSelectorContainer } from './documents/DocumentSelectorContainer';
import { FieldArray } from 'formik';
import { fieldName } from './documents/DocumentSelector.fieldName';

export interface IDocumentsContainerProps {
  baseName: string;
}

export const DocumentsContainer: React.FC<IDocumentsContainerProps> = ({ baseName }) => {
  return (
    <FieldArray name={`${baseName}.${fieldName}`}>
      {({ remove, push }) => <DocumentSelectorContainer baseName={baseName} remove={remove} push={push} />}
    </FieldArray>
  );
};
